import { combineReducers } from '@reduxjs/toolkit'
import { mapPathReducer } from './MapPathSlice'
import { mapGismeteoPrecipitationReducer } from './MapGismeteoPrecipitationSlice'
import { mapRoadWorksReducer } from './MapRoadWorksSlice'
import { mapRoadWorksWithNormativitiesReducer } from './MapRoadWorksWithNormativitiesSlice'
import { mapWaysideLandLotsReducer } from './MapWaysideLandLotsSlice'

export const mapsReducer = combineReducers({
    roadWorks: mapRoadWorksReducer,
    roadWorksWithNormativities: mapRoadWorksWithNormativitiesReducer,
    path: mapPathReducer,
    gismeteoPrecipitation: mapGismeteoPrecipitationReducer,
    waysideLandLots: mapWaysideLandLotsReducer
})